import { render } from "./ProductTourHost.vue?vue&type=template&id=cfc5a8de"
import script from "./ProductTourHost.vue?vue&type=script&lang=js"
export * from "./ProductTourHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__